module.exports = __webpack_public_path__ + "static/media/user-icon-2.ba28d447.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-icon-2.png
// module id = 65
// module chunks = 0